import { render, staticRenderFns } from "./FileUploads.vue?vue&type=template&id=2b57d2e0&scoped=true"
import script from "./FileUploads.vue?vue&type=script&lang=js"
export * from "./FileUploads.vue?vue&type=script&lang=js"
import style0 from "./FileUploads.vue?vue&type=style&index=0&id=2b57d2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57d2e0",
  null
  
)

export default component.exports